import swal from "sweetalert";

$('.uploadPhotoOne').click(function () {
    $('#file').click();
});

$('#file').change(function () {
    var fileList = this.files;
    var anyWindow = window.URL || window.webkitURL;
    //Como puedo subir multimples archivos, hago un for para recorrer todo lo subido
    $("#form_fotos").html('');
    for (var i = 0; i < fileList.length; i++) {
        var objectUrl = anyWindow.createObjectURL(fileList[i]);
        $("#form_fotos").append(fileList[i].name + '<br>');
    }
});

$('#formCreateContract .services .click-element').click(function () {
    $('#formCreateContract .services .click-element').removeClass('active');
    $(this).addClass('active');
    $('#formCreateContract .services .checks_list').removeClass('checks_list_active');
    $('#formCreateContract .services .checks_list_'+this.id).addClass('checks_list_active');
});

$('#formCreateContract .services .element-checks_list').click(function () {
    if($('#formCreateContract .services .element-checks_list #element-checks_list_'+this.id).prop('checked') ) {
        $('#formCreateContract .services .element-checks_list #element-checks_list_'+this.id).prop('checked',false);
        $('#formCreateContract .services .element-checks_list #element-checks_list_'+this.id).val('no');
        $('#formCreateContract .services .services_update .element-'+$(this).attr('idServ')+' h2 .span_'+this.id).css('display','none');
    }else{
        $('#formCreateContract .services .element-checks_list #element-checks_list_'+this.id).prop('checked',true);
        $('#formCreateContract .services .element-checks_list #element-checks_list_'+this.id).val('si');
        $('#formCreateContract .services .services_update .element-'+$(this).attr('idServ')+' h2').append('<span class="span_'+this.id+'">'+$(this).attr('name')+' - </span>');
    }
});


$('#formCreateContract .services .element-checks_list input').click(false);
$('#formCreateContract .fee .element-checks_list input').click(false);
$('#formCreateContract .annual .element-checks_list input').click(false);

$('#formCreateContract .fee .element-checks_list').click(function () {
    if($('#formCreateContract .fee .element-checks_list #'+this.id).prop('checked') ) {
        $('#formCreateContract .fee .element-checks_list #'+this.id).prop('checked',false);
        $('#formCreateContract .fee .element-checks_list #'+this.id).val('no');
    }else{
        $('#formCreateContract .fee .element-checks_list #'+this.id).prop('checked',true);
        $('#formCreateContract .fee .element-checks_list #'+this.id).val('si');
    }
});

$('#formCreateContract .annual .element-checks_list').click(function () {
    if($('#formCreateContract .annual .element-checks_list #'+this.id).prop('checked') ) {
        $('#formCreateContract .annual .element-checks_list #'+this.id).prop('checked',false);
        $('#formCreateContract .annual .element-checks_list #'+this.id).val('no');
    }else{
        $('#formCreateContract .annual .element-checks_list #'+this.id).prop('checked',true);
        $('#formCreateContract .annual .element-checks_list #'+this.id).val('si');
    }
});

$('#formCreateContract .annual .values').keypress(function () {
    validateAnnualValue();
});
$('#formCreateContract .annual .values').keydown(function () {
    validateAnnualValue();
});
$('#formCreateContract .annual .values').keyup(function () {
    validateAnnualValue();
});

function validateAnnualValue(){
    var total_value_annual = 0,
        hosting_value,domain_value = 0,
        technical_support_value,ssl_value = 0,
        content_admin_value = 0;
    setTimeout(function () {
        if ($('#formCreateContract .annual #hosting_value').val() != '') {
            hosting_value = convertNumber($('#formCreateContract .annual #hosting_value').val())
        }else{
            hosting_value=0
        }
        if ($('#formCreateContract .annual #domain_value').val() != '') { domain_value = convertNumber($('#formCreateContract .annual #domain_value').val()) }else{domain_value=0}
        //if ($('#formCreateContract .annual #technical_support_value').val() != '') { technical_support_value = convertNumber($('#formCreateContract .annual #technical_support_value').val()) }else{technical_support_value=0}
        //if ($('#formCreateContract .annual #ssl_value').val() != '') { ssl_value = convertNumber($('#formCreateContract .annual #ssl_value').val()) }else{ssl_value=0}
        if ($('#formCreateContract .annual #content_admin_value').val() != '') { content_admin_value = convertNumber($('#formCreateContract .annual #content_admin_value').val()) }else{content_admin_value=0}
        total_value_annual = parseInt(hosting_value)+parseInt(domain_value)+parseInt(content_admin_value);
        total_value_annual = new Intl.NumberFormat().format(total_value_annual);
        total_value_annual = total_value_annual.replace(/,/g , ".");
        $('#formCreateContract .annual #value_annual').val(total_value_annual);
    },10);
}

function convertNumber(cadena)
{
    cadena = cadena.replace("e", "");
    cadena = cadena.replace("E", "");
    cadena = cadena.replace("-", "");
    cadena = cadena.replace("+", "");
    cadena = cadena.replace(".", "");
    return cadena;
}

$('#formCreateContract .paymennts .values').keypress(function () {
    validatePaymentsValue();
});
$('#formCreateContract .paymennts .values').keydown(function () {
    validatePaymentsValue();
});
$('#formCreateContract .paymennts .values').keyup(function () {
    validatePaymentsValue();
});

function validatePaymentsValue(){
    var total_value_payments = 0,
        iva_value=0,
        value_pay_1=0,
        value_pay_2=0,
        value_pay_3=0,
        value_pay_4=0,
        value_pay_5=0,
        porcent_pay=0;
    setTimeout(function () {
        if ($('#formCreateContract .paymennts #value_iva').val() != '') { iva_value = convertNumber($('#formCreateContract .paymennts #value_iva').val()) }else{iva_value=0}
        if ($('#formCreateContract .paymennts #value_pay_1').val() != '') { value_pay_1 = convertNumber($('#formCreateContract .paymennts #value_pay_1').val()) }else{value_pay_1=0}
        if ($('#formCreateContract .paymennts #value_pay_2').val() != '') { value_pay_2 = convertNumber($('#formCreateContract .paymennts #value_pay_2').val()) }else{value_pay_2=0}
        if ($('#formCreateContract .paymennts #value_pay_3').val() != '') { value_pay_3 = convertNumber($('#formCreateContract .paymennts #value_pay_3').val()) }else{value_pay_3=0}
        if ($('#formCreateContract .paymennts #value_pay_4').val() != '') { value_pay_4 = convertNumber($('#formCreateContract .paymennts #value_pay_4').val()) }else{value_pay_4=0}
        if ($('#formCreateContract .paymennts #value_pay_5').val() != '') { value_pay_5 = convertNumber($('#formCreateContract .paymennts #value_pay_5').val()) }else{value_pay_5=0}
        total_value_payments = parseInt(iva_value)+parseInt(value_pay_1)+parseInt(value_pay_2)+parseInt(value_pay_3)+parseInt(value_pay_4)+parseInt(value_pay_5);
        var total_porcent_payments = total_value_payments;
        total_value_payments = new Intl.NumberFormat().format(total_value_payments);
        total_value_payments = total_value_payments.replace(/,/g , ".");
        $('#formCreateContract .paymennts .total').html('$'+total_value_payments);
        if(parseInt(value_pay_1) >= 0){
            porcent_pay = (100 * parseInt(value_pay_1)) / total_porcent_payments;
            $('#formCreateContract .paymennts #percent_pay_1').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_2) >= 0){
            porcent_pay = (100 * parseInt(value_pay_2)) / total_porcent_payments;
            $('#formCreateContract .paymennts #percent_pay_2').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_3) >= 0){
            porcent_pay = (100 * parseInt(value_pay_3)) / total_porcent_payments;
            $('#formCreateContract .paymennts #percent_pay_3').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_4) >= 0){
            porcent_pay = (100 * parseInt(value_pay_4)) / total_porcent_payments;
            $('#formCreateContract .paymennts #percent_pay_4').val(parseInt(porcent_pay)+'%');
        }
        if(parseInt(value_pay_5) >= 0){
            porcent_pay = (100 * parseInt(value_pay_5)) / total_porcent_payments;
            $('#formCreateContract .paymennts #percent_pay_5').val(parseInt(porcent_pay)+'%');
        }
    },10);
}

var elementsForm,contLogin;

$('#formCreateContract .btnCreateContract').click(function () {
    swal({
        title: "¿Seguro de hacer esto?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
        .then((willDelete) => {
            if (willDelete) {
                swal({
                    text: "Espere un momento",
                    icon: imageURL,
                    button: "OK!",
                });
                $('#formCreateContract').submit();
            } else {
                return false;
            }
        });
});

$("#formCreateContract").on('submit', function (e) {
    e.preventDefault();
    elementsForm = [
        "name_oc",
        "date",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);

    if(contLogin == 0)
    {
        swal({
            text: "Debes completar todos los datos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }

    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    var data = $(this).serialize();
    $.ajax({
        url: https + "createContract",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                uploadPhotoOneCreateContract()
            }else if($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){

        $('#'+elementsForm[i]).removeClass('error');

        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }

    }

    return contLogin;
}

function uploadPhotoOneCreateContract() {

    var $avatarInput = $("#file");
    var formData = new FormData();
    formData.append('photo', $avatarInput[0].files[0]);
    formData.append('name_oc', $("#name_oc").val());
    $.ajax({
        url: https + "createClientUploadPhotoContract",
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (datos) {
            if ($.trim(datos) == "1")
            {
                $("#formCreateContract")[0].reset();
                swal.close();
                swal({
                    text: "Contrato Creado con exito",
                    icon: imageURL,
                    button: false,
                });
                setInterval(function () {
                    location.href = https + 'dashboard';
                }, 200)
            }
            else
            {
                $("#formCreateClient")[0].reset();
                swal.close();
                swal({
                    text: "Cliente Creado con exito",
                    icon: imageURL,
                    button: false,
                });
                setInterval(function () {
                    location.href = https + 'client/'+$('#id_client').val();
                }, 200)
            }
        }
    });

}